"use client";

import appleLink from "@/_assets/svgs/appleLink.svg";
import playLink from "@/_assets/svgs/playLink.svg";
import { useAppSettings } from "@/hooks/useAppSettings";
import Image from "next/image";
import { Link } from "@/i18n/navigation";

interface SocialsButtonsProps {
  platform?: "desktop" | "ios" | "android" | null; // Optional prop
  compact?: boolean;
}

export default function SocialsButtons({
  platform,
  compact = false,
  // isHome = false,
  // isBlog = false,
}: SocialsButtonsProps) {
  // Default to both buttons if no platform prop is passed
  const { data: appSettings } = useAppSettings();
  if (!platform) {
    return (
      <div className="flex items-center gap-4">
        <Link
          href={appSettings?.playstore_link ?? ""}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="relative h-[50px] w-[150px] transition-all hover:opacity-80 xl:h-[45px] xl:w-[170px]">
            <Image
              src={playLink}
              fill
              alt="eSIM Card Android app"
              sizes="auto"
            />
          </div>
        </Link>
        <Link
          href={appSettings?.appstore_link ?? ""}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="relative h-[50px] w-[150px] transition-all hover:opacity-80 xl:h-[45px] xl:w-[170px]">
            <Image src={appleLink} fill alt="eSIM Card iOS app" sizes="auto" />
          </div>
        </Link>
      </div>
    );
  }

  // Conditional single link based on platform and context (isHome/isBlog)
  const showAndroid = platform === "android";
  const showApple = platform === "ios";

  const badgeSizeClasses = compact
    ? "h-[26px] w-[78px] xs:h-[32px] xs:w-[96px] sm:h-[40px] sm:w-[120px]"
    : "h-[40px] w-[120px] sm:h-[50px] sm:w-[150px] xl:h-[45px] xl:w-[170px]";

  return (
    <div className="flex items-center gap-[5rem] md:hidden">
      {showAndroid && (
        <Link
          href={appSettings?.playstore_link ?? ""}
          target="_blank"
          rel="noopener noreferrer"
          className="order-0 md:order-10"
        >
          <div
            className={`relative shrink-0 transition-all hover:opacity-80 ${badgeSizeClasses}`}
          >
            <Image
              src={playLink}
              fill
              alt="eSIM Card Android app"
              sizes="auto"
            />
          </div>
        </Link>
      )}
      {showApple && (
        <Link
          href={appSettings?.appstore_link ?? ""}
          target="_blank"
          rel="noopener noreferrer"
          className="order-0 md:order-10"
        >
          <div
            className={`relative shrink-0 transition-all hover:opacity-80 ${badgeSizeClasses}`}
          >
            <Image src={appleLink} fill alt="eSIM Card iOS app" sizes="auto" />
          </div>
        </Link>
      )}
    </div>
  );
}
